import styled, { css } from 'styled-components'

import { HEADER_HEIGHT_DESKTOP } from '../Quiz/components/Header/styled'

import { fontWeight } from 'src/styles/fonts'
import { color } from 'src/styles/colors'
import { media } from 'src/styles/media'
import { Z_INDEX_QUESTION } from 'src/constants/z-indexes'

export const Wrap = styled.div`
  display: flex;
  min-height: 100%;
  ${media.desktop} {
    min-height: calc(100% - ${HEADER_HEIGHT_DESKTOP}rem);
  }
`

export const HalfWrap = styled.div<{
  withGradient?: boolean
  isHidden?: boolean
}>`
  position: absolute;
  width: 100%;
  min-height: 100%;
  height: auto;
  z-index: ${Z_INDEX_QUESTION};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.desktop} {
    position: relative;
    width: 50%;
    height: unset;
    z-index: unset;
    display: flex;
  }

  ${({ withGradient, isHidden }) => `
      ${
        withGradient
          ? `background-image: linear-gradient(222deg, #fffdee 0%, #fef7e2 100%);`
          : ''
      }
      ${isHidden ? `display: none;` : ''}
    `}
`

export const Hr = styled.hr`
  background-color: ${color.VERY_LIGHT_PINK};
  border: none;
  height: 0.1rem;
  margin: 3rem 0 2.2rem;
  width: 100%;
`

export const QuizEntry = styled.button<{ isActive?: boolean }>`
  height: 7.8rem;
  width: 100%;
  display: flex;
  justify-content: center;

  ${({ isActive }) =>
    isActive &&
    css`
      background-image: linear-gradient(264deg, #fffdee 0%, #fef7e2 100%);
    `};

  :active {
    color: #000;
  }

  :disabled {
    cursor: default;
    color: #000;
  }
`

export const QuizEntryInner = styled.div`
  width: 31.4rem;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FlexWrap = styled.div`
  display: flex;
  align-items: center;
`

export const QuizTitle = styled.span`
  font-weight: ${fontWeight.MEDIUM};
  margin-left: 1.6rem;
  text-align: left;
`
